/**
 * 会议项目工作空间（ConferenceWorkspaceLayout）：与全局 MainLayout 平级，
 * 与医项目 WorkspaceLayout 形态一致。已入库备用，待路由接入后启用。
 *
 * 列表为 `/conf/conferences`，详情段为 `:id`（会议项目 ID）。
 */
export const CONFERENCE_WORKSPACE_ROUTE_BASE = '/conf/conferences';

/** 侧栏「返回」：会议项目列表 */
export const CONFERENCE_WORKSPACE_PARENT_PATH = '/conf/conferences';
